import { useState, useEffect, useRef } from "react";
import './CustomSelect.css';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
export default function CustomSelect({ options, value, onChange, readonly, placeholder}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  const handleSelect = (option) => {
    onChange(option);
    setOpen(false);
  };

  const selectedOption = options.find(o => o.value === value);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="custom-select-wrapper" ref={wrapperRef}>
      <div
        className={`custom-select-display ${readonly ? "disabled" : ""} ${open ? "open" : ""}`}
        onClick={() => !readonly && setOpen(!open)}
      >
        <span className="arrow"><KeyboardArrowDownOutlinedIcon /></span>
        <span>{selectedOption ? selectedOption.label : placeholder}</span>
      </div>

      {open && (
        <ul className="custom-select-options">
          {options.map((option, i) => (
            <li
              key={i}
              onClick={() => handleSelect(option.value)}
              className={option.value === value ? "selected" : ""}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
